import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchProspect, updateProspect } from "@/lib/api";
import type { Prospect } from "@/lib/types";
import type { ProspectUpdate } from "@/lib/review";

export function useProspect(id: string | undefined) {
  return useQuery({
    queryKey: ["prospect", id],
    queryFn: () => fetchProspect(id as string),
    enabled: !!id,
  });
}

export function useReviewMutation(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (update: ProspectUpdate): Promise<Prospect> => updateProspect(id, update),
    onSuccess: (updated) => {
      qc.setQueryData(["prospect", id], updated);
      qc.invalidateQueries({ queryKey: ["prospects"] });
    },
  });
}
